export default __webpack_public_path__ + "static/media/geolocation.7de05c4c.png";